import React from 'react';
import { FiX } from 'react-icons/fi';

interface DeleteContactModalProps {
    isOpen: boolean;
    onClose: () => void;
    onConfirm: () => void;
    contactName: string;
}

const FiXComponent = FiX as unknown as React.ComponentType<{
    size?: number | string;
    className?: string;
}>;

const DeleteContactModal: React.FC<DeleteContactModalProps> = ({
    isOpen,
    onClose,
    onConfirm,
    contactName,
}) => {
    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
            <div className="bg-white rounded-lg shadow-xl w-96 max-w-full mx-4">
                {/* Header */}
                <div className="flex items-center justify-between px-6 py-4 border-b border-gray-200">
                    <h3 className="text-lg font-semibold text-gray-900">Delete Contact</h3>
                    <button
                        onClick={onClose}
                        className="text-gray-400 hover:text-gray-600 transition-colors"
                    >
                        <FiXComponent size={20} />
                    </button>
                </div>

                {/* Body */}
                <div className="px-6 py-4">
                    <p className="text-gray-700">
                        Are you sure you want to delete this contact?
                    </p>
                    {contactName && (
                        <p className="mt-2 text-sm text-gray-500 font-medium">
                            "{contactName}"
                        </p>
                    )}
                    <p className="mt-2 text-sm text-red-600">
                        This action cannot be undone.
                    </p>
                </div>

                {/* Footer */}
                <div className="flex items-center justify-end gap-3 px-6 py-4 border-t border-gray-200">
                    <button
                        onClick={onClose}
                        className="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 rounded-md hover:bg-gray-200 transition-colors"
                    >
                        Cancel
                    </button>
                    <button
                        onClick={onConfirm}
                        className="px-4 py-2 text-sm font-medium text-white bg-red-600 rounded-md hover:bg-red-700 transition-colors"
                    >
                        Delete
                    </button>
                </div>
            </div>
        </div>
    );
};

export default DeleteContactModal;